module.exports = __webpack_public_path__ + "img/index_map_place06.9dc23a0e.jpg";